/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { useState } from 'react';

// ours
import FormatService from '../../services/format.service';
import LiteralsService from '../../services/literals/LiteralsService';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// styles
import styles from './GoalProgressBar.module.scss';

interface GoalProgressBarProps {
    currentAmount: number;
    percent: number;
    targetAmount: number;
}

export default function GoalProgressBar(props: GoalProgressBarProps): JSX.Element {
    const [initialRender, setInitialRender] = useState(true);

    const progressStyles: any = {};
    if (initialRender) {
        progressStyles.width = '0%';
        window.setTimeout(() => setInitialRender(false), 500);
    } else {
        progressStyles.width = `${props.percent}%`;
        if (props.percent > 99) progressStyles.borderRadius = '4px';
    }

    return (
        <div>
            <Typography component="p" variant={TypographyVariants.HEADING_M} key="delta" className="delta">
                {FormatService.format(props.currentAmount)} saved
            </Typography>
            <Typography variant={TypographyVariants.CAPTION} key="delta2" className="delta2">
                {LiteralsService.getLiteral('SavingsDrawer.percentSaved', [props.percent || 0])}
            </Typography>
            <div className={styles.statusBar}>
                <div className={styles.progressBar} />
                <div className={styles.progress} style={progressStyles} />
            </div>
            <div className={styles.progressBarLabels}>
                <Typography variant={TypographyVariants.BODY}>$0</Typography>
                <Typography variant={TypographyVariants.BODY}>
                    {FormatService.formatCompactMoney(props.targetAmount || 0)}
                </Typography>
            </div>
        </div>
    );
}
